var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "1c_data" }, [
    this.data_p.length == 0
      ? _c("div", { staticClass: "panel-tag" }, [
          _vm._v("\n\t\tPanorama не знайдено\n\t"),
        ])
      : _c(
          "div",
          { staticClass: "panel-body" },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { staticClass: "left_pais", attrs: { sm: "4" } },
                  _vm._l(this.data_p, function (pai) {
                    return _c(
                      "div",
                      { staticClass: "bg-light rounded-top mb-2" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "accordion accordion-hover accordion-clean",
                            attrs: { id: "js_list_accordion_2" },
                          },
                          [
                            _c("div", { staticClass: "card" }, [
                              _c("div", { staticClass: "card-header border" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "card-title",
                                    class: {
                                      collapsed: !pai.is_active,
                                      "is_real_active border border-danger":
                                        _vm.check_is_current(pai),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.setActivePai(pai)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fal fa-globe-americas width-2 fs-xl",
                                    }),
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(pai.params.kontragent) +
                                        "\n\t\t\t\t\t\t\t\t\t"
                                    ),
                                    _c("div", { staticClass: "ml-2" }, [
                                      _c("small", [
                                        _vm._v(_vm._s(pai.kadastr) + " "),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("b-col", { staticClass: "right_pais", attrs: { sm: "8" } }, [
                  _c("div", { staticClass: "panorama_fields" }, [
                    _vm.pai_active != null
                      ? _c("div", {
                          staticClass: "descriptions border p-3",
                          domProps: {
                            innerHTML: _vm._s(_vm.pai_active.description),
                          },
                        })
                      : _vm._e(),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }